<mat-dialog-content fxLayout="row" fxLayoutAlign="start top">
  <div class="content" [innerHTML]="data.message"></div>
</mat-dialog-content>

<button *ngIf="!dialogRef.disableClose" type="button" class="text-secondary button-close" mat-dialog-close
  mat-icon-button>
  <net-iconify-icon [icon]="icClose"></net-iconify-icon>
</button>